<template>
  <div>
     <el-drawer
      title="添加出库计划"
      direction="ltr"
      :visible.sync="addYuTi"
      :before-close="addPlanClose"
      size="45%"
    >
      <div style="margin-left:10px;">
        <p>货物信息</p>
        <hr>
        <div style="margin:20px 0 30px 0;" v-for="(item,ix) in allDataList" :key="ix">
          <div>
            <div style="display: flex;justify-content: space-between;">
              <div style="display: flex;margin-bottom:10px;">
                <div>{{(item.cargoControlKey).replace(/,/g,"/")}}</div>
                <div style="display: flex;">
                  <span style="margin-left:20px;">总重量：</span>
                  <div>
                    <span style="color:red">{{item.sumWeight}}</span><span> 吨 </span>
                    <span> / </span><span style="color:red">{{item.num}}</span><span> 件</span>
                  </div>
                </div>
                <div style="display: flex;" v-if="item.surplus">
                  <span style="margin-left:20px;">货权剩余：</span>
                  <div>
                    <span v-if='item.controlWeight == 1'><span style="color:red">{{item.surplusControlWeight}}</span><span> 吨</span></span>
                    <span v-if='item.controlPiece == 1'><span> / </span><span  style="color:red">{{item.surplusControlNumber}}</span><span> 件</span></span>
                  </div>
                </div>
              </div>
              <div style="margin-right:20px;">
                <el-button type="primary" size="mini" @click="delClick(item,ix)">删除</el-button>
              </div>
            </div>
          </div>
          <el-table
            max-height="300px"
            border
            bordersize="mini"
            size="mini"
            ref="tabref"
            :data="item.list"
            style="width:100%;font-size:13px;"
            highlight-current-row
            :header-cell-style="{background:'#F5F5F5',color:'black'}"
        >
          <el-table-column type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
          <el-table-column prop="number" align="center" label="操作" width="60">
            <template slot-scope="scope1">
              <el-button @click="tabDelClick(item,scope1.$index,ix)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="number" align="center" label="件数" width="90">
            <template slot-scope="scope1">
                <el-input
                  v-model="scope1.row.number"
                  @input="changeJianShu(scope1.row,scope1.row.number)"
                  v-number-input.float="0"
                  maxlength="50"
                  placeholder="请输入"
                  size="mini"
                ></el-input>
             </template>
          </el-table-column>
          <el-table-column prop="allWeight" align="center" label="重量(吨)" width="100">
            <template slot-scope="scope1">
                <el-input
                  v-model="scope1.row.allWeight"
                  v-number-input.float="4"
                  maxlength="50"
                  placeholder="请输入"
                  size="mini"
                  :disabled='scope1.row.disWeight'
                  @blur="weightInput(scope1.row,scope1.row.allWeight)"
                ></el-input>
              </template>
          </el-table-column>
          <el-table-column prop="warehouseName" align="center" label="仓位"></el-table-column>
          <el-table-column prop="stockAvailableNumber" align="center" label="仓位可提件数" width="100"></el-table-column>
          <el-table-column prop="yuTiNumber" align="center" label="预提件数" width="100"></el-table-column>
          <el-table-column prop="availableNumber" align="center" label="提单可提" width="100"></el-table-column>
          <el-table-column prop="specification" align="center" label="规格" width="150"></el-table-column>
          <el-table-column prop="placeOfOrigin" align="center" label="产地" width="100"></el-table-column>
          <el-table-column prop="productName" align="center" label="货物类型" width="110"></el-table-column>
          <el-table-column prop="model" align="center" label="材质"  width="120"></el-table-column>
        </el-table>
        </div>
      </div>
      <div class="footerBox">
        <el-button type="primary" @click="addPlanClose">取消</el-button>
        <el-button type="primary" @click="finishClick(1)" :loading = 'addLoading'>保存</el-button>
        <el-button type="primary" :loading="confirmLoadingB" @click="finishClick(2)" >保存并打印</el-button>
      </div>
      <el-drawer
        title="添加货物"
        :modal-append-to-body="false"
        size="100%"
        :visible.sync="addYuTi"
        :modal="false"
        :before-close="addPlanClose"
        class="rightDrawer"
      >
        <div style="margin:62px 0 0 10px;" v-for="(item,index) in detailsDataCopyAdd" :key='index'>
          <div>
            <div style="display: flex;justify-content: space-between;">
              <div style="display: flex;margin-bottom:10px;">
                <div>{{item.productTypeName}} / {{item.specification}} / {{item.model}}</div>
                <div style="display: flex;">
                  <span style="margin-left:20px;">产地：</span>
                  <div>
                    <span>{{item.steelMillName}}</span>
                  </div>
                </div>
                <div style="display: flex;">
                  <span style="margin-left:20px;">件数：</span>
                  <div>
                    <span style="color:red">{{item.number}}</span><span> 件 </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        <el-table
            size="mini"
            :data="item.list"
            ref="item.list"
            style="width:100%;"
            :header-cell-style="{background:'#f5f5f5'}"
            @row-click="dianjixuanzhong"
            highlight-current-row
          >
            <el-table-column prop="warehouseName" align="center" label="仓位"></el-table-column>
            <el-table-column prop="stockAvailableNumber" align="center" label="仓位可提件数"></el-table-column>
          </el-table>
      </div>
      </el-drawer>

    </el-drawer>
  </div>
</template>

<script>
import {
  getEmptyMiniBillStockWarehouse, // 添加出库计划 添加货物列表（来源手动）
  JfvirtualControlBean, // 调用控货接口
  getWeighingMethodList, // 判断计重方式
  JfgetTEmptyStockCustomerGroup,
  JfaddEmptyOutstockJanFaForBill // 添加出库计划确定
} from '@/api/wms-stock.js'
export default {
  components: { },
  name: 'XinzengTidan',
  data () {
    return {
      detailsDataCopyAdd: [],
      billId: '',
      plateNumberOption: [],
      xuanzhongArr: null,
      primaryCustomerTaxId: '',
      secondaryCustomerTaxId: '',
      organizationId: '',
      allDataList: [],
      searchArr: [],
      parentData: {},
      jianShuArr: [],
      addLoading: false,
      confirmLoadingB: false,
      miniBillId: '',
      count: 0,
      paramsObject: {}
    }
  },
  props: {
    addYuTi: {
      type: Boolean,
      default: true
    },
    planData: {
      type: Object
    },
    chePai: {
      type: String
    }
  },
  watch: {
    planData: {
      deep: true,
      immediate: true,
      handler (val) {
        if (val) {
          this.parentData = val
          this.primaryCustomerTaxId = val.primaryCustomerTaxId
          this.secondaryCustomerTaxId = val.secondaryCustomerTaxId
          this.billId = val.billId
          this.miniBillId = val.miniBillId
          this.organizationId = val.organizationId
        }
      }
    }
  },
  created () {
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        _this.finishClick(2)
      }
    }
  },
  mounted () {
    this.getStockWarehouse()
  },
  methods: {
    // 点击
    dianjixuanzhong (row) {
      // console.log(row)
      this.xuanzhongArr = {}
      // this.detailsDataCopyAdd.forEach(item => {
      //   if (item.miniBillDetailId == row.miniBillDetailId) {
      //     this.$set(row, 'yuTiNumber', item.number)
      //   }
      // })
      this.detailsDataCopyAdd.forEach(item => {
        if (item.miniBillDetailId == row.miniBillDetailId) {
          this.$set(row, 'yuTiNumber', Math.min(row.stockAvailableNumber / 1, item.number / 1))
        }
      })
      this.xuanzhongArr = row
      this.JfvirtualControlBean()
      this.getWeighingMethod()
      this.JfgetTEmptyStockCustomerGroup()
    },
    delClick (item, ix) {
      this.allDataList.splice(ix, 1)
    },
    tabDelClick (item, ix, index) {
      item.list.forEach((item1, index1) => {
        if (index1 == ix) {
          item.list.splice(ix, 1)
          if (item.list.length == 0) {
            item.num = 0
            item.sumWeight = 0
            this.delClick(item, index)
          } else {
            this.allDataList.forEach((item, index) => {
              this.$set(item, 'num', item.list.reduce((pre, cur) => { return pre / 1 + cur.number / 1 }, 0))
              this.$set(item, 'sumWeight', (item.list.reduce((pre, cur) => { return pre / 1 + cur.allWeight / 1 }, 0)).toFixed(4))
            })
          }
        }
      })
    },
    // 添加出库计划取消
    addPlanClose () {
      this.$emit('update:addYuTi', false)
      this.$parent.xztableData = []
    },
    // 获取添加货物列表
    getStockWarehouse () {
      getEmptyMiniBillStockWarehouse({
        billId: this.billId,
        miniBillId: this.miniBillId
      }).then(res => {
        this.detailsDataCopyAdd = res
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 判断计重方式
    getWeighingMethod () {
      getWeighingMethodList({
        productType: this.xuanzhongArr.productType
      }).then(res => {
        if (res[0].outWeighingMethod == 1) {
          this.$set(this.xuanzhongArr, 'disWeight', true)
        } else {
          this.$set(this.xuanzhongArr, 'disWeight', false)
        }
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 获取单件理重
    JfgetTEmptyStockCustomerGroup () {
      JfgetTEmptyStockCustomerGroup({
        primaryCustomerTaxId: this.primaryCustomerTaxId, // （一级货主id  必填）
        customerTaxId: this.secondaryCustomerTaxId, // （二级货主id 必填）
        productType: this.xuanzhongArr.productType, // （货物类型id  非必填）
        steelMillName: this.xuanzhongArr.steelMillName, // （产地  非必填）
        model: this.xuanzhongArr.model, // （材质 非必填）
        specification: this.xuanzhongArr.specification // （规格  非必填）
      }).then(res => {
        this.$set(this.xuanzhongArr, 'singletonWeight', res[0].singletonWeight)
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 调用控货接口
    JfvirtualControlBean () {
      JfvirtualControlBean({
        oneCustomerTaxId: this.primaryCustomerTaxId, // （一级货主纳税人识别号  必填）
        twoCustomerTaxId: this.secondaryCustomerTaxId, // （二级货主纳税人识别号  必填）
        organizationId: this.organizationId, // （仓储租户id  必填）
        productionPlaceName: this.xuanzhongArr.placeOfOrigin, // （产地  必填）
        specificationName: this.xuanzhongArr.specification, // （规格  必填）
        materialName: this.xuanzhongArr.model, // （材质  必填）
        goodTypeName: this.xuanzhongArr.productName // （货物类型名称  必填
      }).then(res => {
        // console.log(JSON.parse(res), 'res')
        // controlPiece: 1  // 控件  0不控  1控
        // controlWeight: 1 // 控吨  0不控  1控
        // isEnable: 1    //控货不控货标识   1控  2不控
        if (res) {
          let isEnableObj = {}
          isEnableObj = JSON.parse(res)
          this.$set(this.xuanzhongArr, 'number', '')
          this.$set(this.xuanzhongArr, 'weight', '')
          this.$set(this.xuanzhongArr, 'allWeight', '')
          this.$set(this.xuanzhongArr, 'productTypeName', this.xuanzhongArr.productName)
          this.$set(this.xuanzhongArr, 'billDetailId', this.xuanzhongArr.billDetailId)
          // 控货
          if (isEnableObj.isEnable == '1') {
            let str = (isEnableObj.productionPlaceName ? isEnableObj.productionPlaceName : '') + ',' +
                      (isEnableObj.goodTypeName ? isEnableObj.goodTypeName : '') + ',' +
                      (isEnableObj.specificationName ? isEnableObj.specificationName : '') + ',' +
                      (isEnableObj.materialName ? isEnableObj.materialName : '')

            // console.log(str, 'str')
            if (str == ',,,') {
              str = '总控'
            }
            this.$set(this.xuanzhongArr, 'cargoControlKey', str)
            if (this.allDataList.some(item => item.cargoControlKey == str)) {
              let index = this.allDataList.findIndex(item => item.cargoControlKey == str)
              this.allDataList[index].list.push(this.xuanzhongArr)
              this.allDataList[index].list = Array.from(new Set(this.allDataList[index].list))
            } else {
              let obj = {
                cargoControlKey: str,
                releaseFlag: 0,
                list: [],
                num: 0,
                sumWeight: 0,
                surplus: true,
                surplusControlWeight: isEnableObj.surplusControlWeight,
                surplusControlNumber: isEnableObj.surplusControlNumber,
                controlWeight: isEnableObj.controlWeight,
                controlPiece: isEnableObj.controlPiece,
                strictReminder: isEnableObj.strictReminder,
                isEnable: isEnableObj.isEnable
              }
              obj.list.push(this.xuanzhongArr)
              this.allDataList.push(obj)
            }
            console.log(this.allDataList, 'this.allDataList')
          } else {
            // 不控
            this.$set(this.xuanzhongArr, 'cargoControlKey', '不控货')
            if (this.allDataList.some(item => item.cargoControlKey == '不控货')) {
              let index = this.allDataList.findIndex(item => item.cargoControlKey == '不控货')
              this.allDataList[index].list.push(this.xuanzhongArr)
              this.allDataList[index].list = Array.from(new Set(this.allDataList[index].list))
            } else {
              let obj = {
                cargoControlKey: '不控货',
                list: [],
                num: 0,
                sumWeight: 0,
                surplus: false
              }
              obj.list.push(this.xuanzhongArr)
              this.allDataList.push(obj)
            }
            console.log(this.allDataList, 'this.allDataList')
          }
        }
      }).catch(err => {
        this.$message.error(err.message)
      })
      // }
    },
    changeJianShu (row, val) {
      if (val) {
        this.$set(row, 'weight', (row.number / 1 * row.singletonWeight).toFixed(4))
        this.$set(row, 'allWeight', (row.number / 1 * row.singletonWeight).toFixed(4))
      } else {
        this.$set(row, 'weight', '0.000')
        this.$set(row, 'allWeight', '0.000')
      }
      // console.log(row, val)
      // console.log(this.allDataList, 'this.allDataList')
      this.allDataList.forEach((item, index) => {
        this.$set(item, 'num', item.list.reduce((pre, cur) => { return pre / 1 + cur.number / 1 }, 0))
        this.$set(item, 'sumWeight', (item.list.reduce((pre, cur) => { return pre / 1 + cur.allWeight / 1 }, 0)).toFixed(4))
      })
    },
    weightInput (row, val) {
      row.allWeight = Number(val).toFixed(4)
      this.allDataList.forEach(item => {
        this.$set(item, 'num', item.list.reduce((pre, cur) => { return pre / 1 + cur.number / 1 }, 0))
        this.$set(item, 'sumWeight', (item.list.reduce((pre, cur) => { return pre / 1 + cur.allWeight / 1 }, 0)).toFixed(4))
      })
    },
    finishClick (n) {
      if (this.allDataList.length == 0) {
        this.$message.error('请选择右侧数据填写货物信息再点击保存')
      } else {
        let flagA = this.allDataList.every(item => item.num / 1 != 0)
        if (!flagA) {
          this.$message.error('件数不能为空或0')
          return
        }
        let flagB = true
        this.allDataList.forEach(item => {
          flagB = item.list.every(im => !!im.number || !!im.allWeight)
        })
        if (!flagB) {
          this.$message.error('信息填写不完整')
          return
        }
        let flagC = true
        this.allDataList.forEach(item => {
          flagC = item.list.every(im => im.number < im.yuTiNumber || im.number == im.yuTiNumber)
        })
        if (!flagC) {
          this.$message.error('所输入的件数不能大于预提件数')
          return
        }
        let flagD = true
        this.allDataList.forEach(item => {
          flagD = item.list.every(im => im.number < im.availableNumber || im.number == im.availableNumber)
        })
        if (!flagD) {
          this.$message.error('所输入的件数不能大于提单可提')
          return
        }
        if (flagA && flagB && flagC && flagD) {
          this.paramsObject = {
            tEmptyOutstockMaster: {
              miniBillId: this.miniBillId, // （预提单主表id  非必填
              miniBillNo: this.parentData.miniBillNo,
              billId: this.billId,
              primaryCustomerName: this.parentData.primaryCustomerName, // （一级货主名称  必填）
              primaryCustomerTaxId: this.parentData.primaryCustomerTaxId, // （一级货主id  必填）
              customerName: this.parentData.secondaryCustomerName, // （二级货主名称  必填）
              customerTaxId: this.parentData.secondaryCustomerTaxId, // （二级货主id 必填）
              outstockPlateNumber: this.parentData.plateNumber, // （出库车牌号  必填）
              outBillNo: this.parentData.outBillNo, // （客户单号 必填 来源提单主表）
              billDriverId: this.parentData.billDriverId, // （提单司机id 必填）
              driverName: this.parentData.driverName, // （司机姓名  必填）
              carHoldFalg: '0', // （扣车标记 0：不扣，1：扣车 必填）
              telephone: this.parentData.telephone, // （司机手机 非必填）
              idNumber: this.parentData.idNumber, // （身份证号 非必填）
              remark: '' // （出库单备注 非必填）
            },
            queryList: this.allDataList
          }
          this.recursionCheck(0, n)
        }
      }
    },
    // 调接口
    addOutStock (n) {
      if (n == '1') {
        this.addLoading = true
      } else {
        this.confirmLoadingB = true
      }
      JfaddEmptyOutstockJanFaForBill(this.paramsObject).then(res => {
        if (n == '1') {
          this.addLoading = false
          this.$emit('update:addPlanBillVisible', false)
          this.$message.success('添加成功')
          this.addPlanClose()
          this.$parent.JfgetConfirmedExpLists()
        } else {
          this.confirmLoadingB = false
          this.$emit('update:addPlanBillVisible', false)
          this.$message.success('添加成功')
          this.addPlanClose()
          this.$router.push({
            path: '/zhuangcheDanPrint',
            query: {
              id: res
            }
          })
        }
      }).catch(err => {
        if (n == '1') {
          this.addLoading = false
        } else {
          this.confirmLoadingB = false
        }
        if (err.code == '-200') {
          this.$message.error(JSON.parse(err.message).msg)
          let cargoControlKey = JSON.parse(err.message).cargoControlKey
          if (cargoControlKey != '不控货') {
            let paramsObj = {}
            if (cargoControlKey == '总控') {
              paramsObj = {
                oneCustomerTaxId: this.primaryCustomerTaxId, // （一级货主纳税人识别号  必填）
                twoCustomerTaxId: this.secondaryCustomerTaxId, // （二级货主纳税人识别号  必填）
                organizationId: this.organizationId // （仓储租户id  必填）
              }
            } else {
              let controlKeyArr = cargoControlKey.split(',')
              paramsObj = {
                oneCustomerTaxId: this.primaryCustomerTaxId, // （一级货主纳税人识别号  必填）
                twoCustomerTaxId: this.secondaryCustomerTaxId, // （二级货主纳税人识别号  必填）
                organizationId: this.organizationId, // （仓储租户id  必填）
                productionPlaceName: controlKeyArr[0], // （产地  必填）
                goodTypeName: controlKeyArr[1], // （货物类型名称  必填
                specificationName: controlKeyArr[2], // （规格  必填）
                materialName: controlKeyArr[3] // （材质  必填）
              }
            }
            JfvirtualControlBean(paramsObj).then(res => {
              let isEnableObjB = JSON.parse(res)
              for (let index = 0; index < this.allDataList.length; index++) {
                console.log(this.allDataList[index], 'this.allDataList[index]')
                if (this.allDataList[index].cargoControlKey == cargoControlKey) {
                  this.allDataList[index].surplusControlWeight = isEnableObjB.surplusControlWeight
                  this.allDataList[index].surplusControlNumber = isEnableObjB.surplusControlNumber
                }
              }
            }).catch(err => {
              this.$message.error(err.message)
            })
          }
        } else {
          this.$message.error(err.message)
        }
      })
    },
    // 递归调用
    recursionCheck (index, n) {
      console.log('asdfasdfads', index)
      if (index < 0) {
        return
      }
      if (index == this.allDataList.length) {
        this.addOutStock(n)
      }
      if (index > this.allDataList.length) {
        // todo
      }
      const item = this.allDataList[index]
      // if (item) {
      if (item.isEnable == '1') {
        // 严控
        if (item.strictReminder == '0') {
          if (item.controlPiece == '1' && item.controlWeight == '1') {
            if (item.num > item.surplusControlNumber || item.sumWeight > item.surplusControlWeight) {
              this.$message.error((item.cargoControlKey).replace(/,/g, '') + '所输入的数据大于货权剩余量')
            } else {
              this.recursionCheck(index + 1, n)
            }
          } else if (item.controlPiece == '1') { // 控件
            if (item.num > item.surplusControlNumber) {
              this.$message.error((item.cargoControlKey).replace(/,/g, '') + '所输入的件数大于货权剩余量')
            } else {
              this.recursionCheck(index + 1, n)
            }
          } else if (item.controlWeight == '1') { // 控吨
            if (item.sumWeight > item.surplusControlWeight) {
              this.$message.error((item.cargoControlKey).replace(/,/g, '') + '所输入的重量大于货权剩余量')
            } else {
              this.recursionCheck(index + 1, n)
            }
          }
        } else {
          console.log('提示')
          // 提示
          if (item.controlPiece == '1') {
            if (item.num > item.surplusControlNumber) {
              this.$message.error((item.cargoControlKey).replace(/,/g, '') + '所输入的件数大于货权剩余量')
              return
            }
          }
          if (item.controlWeight == '1') {
            console.log('控吨')

            if (item.sumWeight > item.surplusControlWeight) {
              this.$confirm((item.cargoControlKey).replace(/,/g, '') + '所输入的重量大于货权剩余量，是否继续', '提示', {
                confirmButtonText: '继续',
                cancelButtonText: '取消',
                closeOnClickModal: false,
                type: 'warning'
              }).then(() => {
                item.releaseFlag = 1
                console.log(item.cargoControlKey, item.releaseFlag)
                this.recursionCheck(index + 1, n)
              }).catch(() => {
              })
            } else {
              this.recursionCheck(index + 1, n)
            }
          } else {
            this.recursionCheck(index + 1, n)
          }
        }
      } else {
        this.addOutStock(n)
      }
      // }
    }
  }
}
</script>

<style>

</style>
